const SAFE_FOCUS_PATCHED = Symbol('safeFocusPatched');

export const isEditorViewReady = (editor) => Boolean(editor && !editor.isDestroyed && editor.view);

const wrapChainFocus = (editor, chain) => {
    const originalFocus = chain.focus.bind(chain);
    chain.focus = (...args) => {
        if (!isEditorViewReady(editor)) return chain;
        return originalFocus(...args);
    };
    return chain;
};

/**
 * Makes `editor.chain().focus()` and `editor.commands.focus()` no-ops when the
 * ProseMirror view is not mounted yet, avoiding TipTap's unhandled error:
 * "The editor view is not available. Cannot access view['hasFocus']".
 *
 * Idempotent — safe to call multiple times on the same editor instance.
 */
export const patchEditorForSafeFocus = (editor) => {
    if (!editor || editor[SAFE_FOCUS_PATCHED]) return editor;

    const originalChain = editor.chain.bind(editor);
    editor.chain = () => wrapChainFocus(editor, originalChain());

    const originalCommandFocus = editor.commands.focus.bind(editor.commands);
    editor.commands.focus = (...args) => {
        if (!isEditorViewReady(editor)) return false;
        return originalCommandFocus(...args);
    };

    editor[SAFE_FOCUS_PATCHED] = true;
    return editor;
};
